<template>
  <div class="ordercontent">
    <div>
      <img :src="meal.image" alt="" />
    </div>
    <div>
      <h3>{{ meal.name }}</h3>
      <div class="price">
        <h3>${{ (meal.price*(meal.count === 0 ? 1 : meal.count)).toFixed(2) }}</h3>
        <div>
          <button @click="subtract(meal, $event)">-</button>
          <div>{{meal.count || 1}}</div>
          <button @click="add(meal, $event)">+</button>
        </div>
      </div>
      <h6>套餐包括以下菜式</h6>
      <div class="ordermeal">
        <div v-for="(item, index) in meal.classify" :key="index">
          <p>{{ item.name }}</p>
          <hr />
          <div class="orderdishes">
            <div class="firstBox" v-for="(el, key) in item.dishes" :key="key">
              <div class="secondBox">
                <div>
                  <img :src="el.image" alt="" />
                </div>
                <div>
                  <span>{{ el.name }}</span
                  ><br /><span>數量: {{ el.count || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["meal", "name"],
  data() {
    return {};
  },
  methods: {
    subtract(i, e) {
      let sub = e.target.nextElementSibling.innerText;
      sub--;
      let count = i.count;
      if (sub < 0) {
        e.target.nextElementSibling.innerText = 0;
        this.$set(i, "count", 0);
      } else {
        e.target.nextElementSibling.innerText = sub;
        this.$set(i, "count", sub);
      }
    },
    add(i, e) {
      let add = e.target.previousElementSibling.innerText;
      add++;
      this.$set(i, "count", add);
      e.target.previousElementSibling.innerText = add;
    },
  },
};
</script>
